export const kpiConstants = {
    STORE_KPI_SUCCESS: 'KPI_STORE_SUCCESS',
    CLEAR_KPI_SUCCESS: 'CLEAR_STORE_SUCCESS',
    STORE_KPI_FAILURE: 'KPI_STORE_FAILURE',

};